import { snackbarService } from "../services/snackbarService";
export const handleError = ({ error, defaultError = "Произошла ошибка", noConnectionMessage = "Это действие недоступно в офлайн режиме", timeoutMessage = "Превышено время ожидания загрузки данных. Повторите действие или обновите страницу", showSnackbar = true, setIsFetching, setError, }) => {
    var _a;
    const normalizedError = normalizeError({
        error,
        defaultError,
        noConnectionMessage,
        timeoutMessage,
    });
    if (setIsFetching)
        setIsFetching(false);
    if (setError) {
        setError(normalizedError);
    }
    if (showSnackbar)
        snackbarService.show({
            variant: "error",
            message: normalizedError.message,
        });
    if ("response" in error && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
        throw error;
    }
};
export const normalizeError = ({ error, defaultTitle = "Упс...", defaultError = "Произошла ошибка, повторите позже", noConnectionMessage = "Это действие недоступно в офлайн режиме", timeoutMessage = "Превышено время ожидания загрузки данных. Повторите действие или обновите страницу", }) => {
    var _a, _b, _c, _d, _e;
    const onLine = navigator.onLine;
    const isTimeouted = Boolean(String(error).includes("timeout"));
    return "response" in error &&
        error.response &&
        Array.isArray((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.errors)
        ? Object.assign(Object.assign({}, error.response.data.errors[0]), { message: isTimeouted
                ? timeoutMessage
                : onLine
                    ? (_c = (_b = error.response.data.errors[0].presentationData) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : defaultError
                    : noConnectionMessage, title: (_e = (_d = error.response.data.errors[0].presentationData) === null || _d === void 0 ? void 0 : _d.title) !== null && _e !== void 0 ? _e : defaultTitle }) : Object.assign(Object.assign({}, error), { message: isTimeouted
            ? timeoutMessage
            : onLine
                ? defaultError
                : noConnectionMessage, title: defaultTitle });
};
//# sourceMappingURL=error.js.map